export default {
  placeholder: {
    en: 'Search',
  },
}
